<template>
  <b-card v-if="template" :class="`dashboard-csr-initiative`" body-class="pb-0">
    <b-card-header class="d-none d-md-block pt-0 ">
      <b-row>
        <b-col class="px-0 d-flex justify-content-start align-items-center">
          <span class="headline-icon mr-2">{{ template.icon }}</span>
          <span class="headline ml-1" style="line-height: 22px">{{ template.headline }}</span>
        </b-col>
      </b-row>
    </b-card-header>

    <b-card-body class="p-2 px-0">
      <b-row>
        <b-col>
          <div class="w-100 mb-2 mt-2 d-flex  flex-xl-row flex-lg-row flex-md-column flex-sm-column justify-content-between align-items-center">
            <div class="point-box">
              <div v-if="isPreview" class="point float-left mr-2">{{ randomNumber }}</div>
              <div v-else class="point float-left mr-2">{{ progress > template.goal ? template.goal : progress }}</div>
              <div class="label-box float-left mr-2">
                <strong>{{ template.display ? template.display.firstLine : ' - ' }}</strong><br/>
                <span class="small">{{ template.display ? template.display.secondLine : '' }}</span>
              </div>
            </div>
            <div style="max-width: 180px; font-size: 13px" v-html="goalText"></div>
          </div>
          <b-progress v-if="isPreview" :value="randomNumber" :max="345" />
          <b-progress v-else :value="progress" :max="template.goal ? template.goal : 0"/>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-footer class="text-center">
      <b-link v-b-modal="`csr-details-${template.headline}`">
        Learn More
      </b-link>
    </b-card-footer>

    <b-modal :id="`csr-details-${template.headline}`" title="Our Initiative" hide-footer>
      <div v-html="template.description"></div>
    </b-modal>

  </b-card>
</template>

<script>
import LeaderboardDetailsModal from '@/modals/leaderboard-details-modal';
import { formatDate } from '@src/filters';

export default {
  props: {
    progress: {
      type: Number
    },
    isPreview: {
      type: Boolean
    },
    template: {
      type: Object,
      default: () => ({
        headline: 'Every action on this platform helps us make our planet greener!',
        icon: '🌿',
        description: `<p>For every job you share with your network and referral you make we will plant a tree to help the Yucatan Restoration project.</p>
        <p>Our target is to plant 345 trees per month and you can help simply by sharing and referring.</p>
        <p>Read more about the details here: <a href="https://www1.plant-for-the-planet.org/yucatan" rel="external" target="_blank">Plant For The Planet</a></p>`,
        goal: 365,
        display: {
          firstLine: 'Trees',
          secondLine: 'Planted',
          text: 'Help us reach our goal to plant {totalSum} trees this month.'
        },
      }),
    },
  },
  components: {
    LeaderboardDetailsModal,
  },
  computed: {
    goalText() {
      const { display, goal } = this.template || {};
      const { text } = display || {};
      return text ? text.replace('{{GOAL}}', `<strong>${goal || ''}</strong>`) : '';
    },
    randomNumber() {
      return Math.floor(Math.random() * 150 + 50);
    }
  },
  methods: {
    formatDate,
    overallProgress(unit) {
      const { convertValue } = this;
      const { conversion, decimals, monthlyGoal } = unit;
      const { totalSum } = monthlyGoal || {};
      return this.leaderboardMonthlyPoints.reduce((sum, points) => {
        let val = convertValue(points, conversion, decimals, totalSum);
        if (typeof val === 'string') {
          val = parseFloat(val);
        }
        console.log({ val });
        return sum += val;
      }, 0);
    },
    convertValue(points, conversion, decimals, cap) {
      if (typeof points === 'number') {
        let value = points * (conversion || 1);
        if (cap && typeof cap === 'number') {
          value = value > cap ? cap : value;
        }
        if (decimals) {
          value = value.toFixed(decimals);
        } else {
          value = Math.round(value);
        }
        return value;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
.dashboard-csr-initiative {
  .card-header {
    background: white;
    .headline {
      font-weight: bold;
    }
    .headline-icon {
      font-size: 24px;
    }
  }
  .card-body {
    .section-title {
      font-weight: bold;
      font-size: 16px;
    }

    .point-box {
      overflow: hidden;
      .point {
        font-weight: bold;
        font-size: 30px;
        line-height: 30px;
      }
      .label-box {
        line-height: 15px;
        .small {
          font-size: 13px;
        }
      }
    }

  }
  .card-footer {
    background-color: inherit;
  }
}
.dashboard-csr-initiative__dashboard {
  .card-header {
    background: white;
    .headline {
      font-weight: bold;
    }
    .headline-icon {
      font-size: 20px;
    }
  }
  .card-body {
    .section-title {
      font-weight: bold;
      font-size: 14px;
    }

    .point-box {
      overflow: hidden;
      .point {
        font-weight: bold;
        font-size: 24px;
        line-height: 24px;
      }
      .label-box {
        line-height: 13px;
        .small {
          font-size: 11px;
        }
      }
    }

  }
  .card-footer {
    background-color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/collective-goal.vue